module.exports = __webpack_public_path__ + "static/img/abort_back2.4353a6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/abort_back2.png
// module id = C9fD
// module chunks = 0